export class AtlTableSortEvent extends CustomEvent<{ payload: string }> {
   static EVENT_NAME = 'sorting-click';
   constructor(id: string) {
      super(AtlTableSortEvent.EVENT_NAME, {
         detail: { payload: id },
         bubbles: true,
         composed: true,
      });
   }
}
